<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate/>
    </div>
    <div v-else>
      <v-container fluid grid-list-xxl px-0 py-0>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3 v-for="post in posts" :key="post.id">
            <v-hover>
              <base-card
                slot-scope="{ hover }"
                color="secondary"
                :class="{'elevation-12 scale-down' : hover}"
                :to="{ name: 'news.single', params: { newsSlug: post.slug }}"
              >
                <v-img
                  v-if="post.media"
                  sizes="300px"
                  :height="$vuetify.breakpoint.xs ? undefined : '250px'"

                  :src="post.media.url"
                  :srcset="post.media.srcset"
                  :style="{'background-color': post.media.color }"
                />

                <v-card-title primary-title>
                  <div class="content-area">
                    <h3 class="heading">{{ post.title }}</h3>
                    <span class="grey--text text--darken-3">{{ post.publish_date }}</span>
                    <div class="mt-2">{{ post.excerpt }}</div>
                  </div>
                </v-card-title>
              </base-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="text-xs-right mt-4" v-if="posts.length">
      <v-pagination
        @input="fetchData"
        :disabled="loading"
        :value="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="7"
      />
    </div>
  </div>
</template>

<script>
import { ErrorHandler } from "@/utils/ErrorHandler";
const handler = new ErrorHandler();

export default {
  created() {
    this.fetchData(1);
  },

  data() {
    return {
      loading: true,
      posts: [],
      pagination: {}
    };
  },

  methods: {
    async fetchData(page) {
      this.loading = true;
      await handler.handle(async () => {
        const res = await this.$axios.get(
          `posts?include=media&limit=12&page=${page}`
        );
        this.posts = res.data["data"];
        this.pagination = res.data["meta"];
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
h3.heading {
  font-size: 1.3rem !important;
}
.v-card {
  .content-area {
    max-height: 190px;
    overflow: hidden;
  }
}
</style>
